import { Swiper, Pagination } from 'swiper/js/swiper.esm.js';
import { breakpoint } from './breakpoint';

// Install modules
Swiper.use([Pagination]);

const sliders = (() => {
    const init = () => {
        if(breakpoint.large('up')) {
            const logos = new Swiper('.swiper-logo', {
                spaceBetween: 16,
                slidesPerView: "auto",
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 40
                    },
                    1440: {
                        slidesPerView: 6,
                        spaceBetween: 60
                    }
                }
            });
        }
    };

    return {
        init: init
    };
})();

export {sliders}
